module.exports = __webpack_public_path__ + "static/media/email-fill.e9e93696.svg";